<template>
    <div class="bannerNode flexColumn">
        <top-tab
            :topBarDatas="topBarDatas"
        ></top-tab>
        <div class="contentBox">
            <box-border
                title="人力资源"
                :boxStyle="{
                    'grid-row': '1 / span 3'
                }"
            >
                <span class="PAVstyle">
                    P: {{ overallProgress.otherObj.P }} A: {{ overallProgress.otherObj.A }} V: {{ overallProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="overallProgress"
                    :option="overallProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
        </div>
    </div>
</template>
<script>
    export default{
        name: 'PlanFive',
        data(){
            const obj = {
                dataZoom: [
                    {
                        height: this.fontSizeFn(20),
                        moveHandleSize: 0,
                        bottom: 10,
                        textStyle: {
                            color: '#8392A5'
                        },
                        dataBackground: {
                        areaStyle: {
                            color: '#8392A5'
                        },
                        lineStyle: {
                            opacity: 0.8,
                            color: '#8392A5'
                        }
                        },
                        brushSelect: true
                    }, {
                        type: 'inside',
                        filterMode: 'filter'
                    }
                ]
            }
            return {
                //overallProgress
                overallProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    grid: {
                        top: '15%',
                        bottom: this.fontSizeFn(35),
                        right: '2%'
                    },
                    color: [1, 0, 1, 0],
                    legend: {
                        top: '0%',
                    },
                    tooltip: {
                        formatter: function(datas){
                            let html = `${datas[0].axisValue} <br />`;
                            datas.forEach((item, index) => {
                                if(index == 0 || index == 1){
                                    if(typeof item.value === 'number'){
                                        html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                                    }
                                }
                                if(index == 3){
                                    (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>本周偏差&nbsp;&nbsp;${item.data.s5}<br/>`)
                                }
                            })
                            return html;
                        }
                    },
                    ...obj
                },
                topBarDatas: [],
                stype: 'Overall',
            }
        },
        mounted() {
            this.topBarDatas = [
                {
                    name: 'Overall',
                    fn: () => {
                        this.stype = 'Overall';
                        this.renderFn();
                    }
                },
                {
                    name: 'Installation',
                    fn: () => {
                        this.stype = 'Installation';
                        this.renderFn();
                    }
                },
                {
                    name: 'Armpass',
                    fn: () => {
                        this.stype = 'Armpass';
                        this.renderFn();
                    }
                },
            ]
        },
        methods: {
            renderFn(){
                const getxhrArr = [
                    async () => {
                        this.getNewVTos({
                                id: '8acba68d9082745b0190bf4db36b0304',
                                stype: this.stype
                            },
                            [
                                ['本周计划', '本周实际', '本周计划', '本周实际'],
                                ['line', 'line', 'bar', 'bar'],
                            ],
                            this.$refs.overallProgress.myChart,
                            {
                                name: 'overallProgress',
                                hasMoreData: ['s5'],
                            },
                            (res) => {
                                this.$nextTick(() => {
                                    this.$refs.overallProgress.myChart.dispatchAction({
                                        type: 'showTip',
                                        seriesIndex: 0,
                                        dataIndex: res.s2.findLastIndex(item => item !== ' ')
                                    });
                                    const dataIndex = res.s2.findLastIndex(item => item !== ' ');
                                    this.$set(this.overallProgress.otherObj, 'P', res.s1[dataIndex]);
                                    this.$set(this.overallProgress.otherObj, 'A', res.s2[dataIndex]);
                                    this.$set(this.overallProgress.otherObj, 'V', res.s5[dataIndex]);
                                })
                            }
                        )
                    }
                ];
                this.getAllPromise(getxhrArr);
            }
        },
    }
</script>
<style lang="less" scoped>
    .banner{
        padding-top: 0.12rem;
    }
    .contentBox{
        height: 92%;
        width: 100%;
        .gridStyle(1, 1, 0.1rem, 0.1rem);
    }
</style>